import { headerStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaHeader";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

headerStyles.headerGridContainer = {
    ...headerStyles.headerGridContainer,

    css: css`
        overflow: hidden;
        margin-bottom: 20px;

        ${mediaQueriesBP.minMD} {
            margin-bottom: 40px;
        }
    `,
};

headerStyles.titleGridItem = {
    ...headerStyles.titleGridItem,

    width: [10, 10, 10, 6, 6],
};

headerStyles.buttonsGridItem = {
    ...headerStyles.buttonsGridItem,

    width: [2, 2, 2, 6, 6],
};

headerStyles.title = {
    ...headerStyles.title,

    variant: "h1",

    css: css`
        margin: 0;
    `,
};
